import React, { Component } from 'react'

class NotFound extends Component {
    render() {
        return (
            <div style = {{ color : "white"}}>
                404 Not Found
            </div>
        )
    }
}
export default NotFound;